import classnames from 'classnames/bind'
import Image from '@/components/common/Image'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

function SimpleHeader() {
  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <div className={cx('header-logo')} onClick={() => window.open(EXTERNAL_LINK.AREA02_OFFICIAL_SITE, '_blank')}>
          <Image src={`/images/area02-logo.jpg`} width={155} height={45} alt={'AREA02'} />
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
